import { z } from 'zod';

export const inclusionPolicyScopeSchema = z.enum([
  'pricingTableDisplay',
  'pricingTableTotal',
  'versionPrice',
  'budget',
  'export',
]);

export const inclusionDecisionSchema = z.enum(['include', 'exclude']);

export const parentChildInclusionModeSchema = z.enum([
  'includeParentAndChildren',
  'includeParentOnly',
  'includeChildrenOnly',
  'excludeParentAndChildren',
]);

export const inclusionPolicyRulesSchema = z.object({
  hiddenItems: inclusionDecisionSchema,
  optionalItems: inclusionDecisionSchema,
  lineItems: inclusionDecisionSchema,
  manualLineItems: inclusionDecisionSchema,
  parentItems: inclusionDecisionSchema,
  childItems: inclusionDecisionSchema,
  subitems: inclusionDecisionSchema,
  deletedItems: inclusionDecisionSchema,
  excludedItems: inclusionDecisionSchema,
  parentChildMode: parentChildInclusionModeSchema,
});

export const pricingInclusionPolicySchema = inclusionPolicyRulesSchema.extend({
  scope: inclusionPolicyScopeSchema,
});

export const pricingInclusionPoliciesSchema = z.object({
  pricingTableDisplay: inclusionPolicyRulesSchema.extend({
    scope: z.literal('pricingTableDisplay'),
  }),
  pricingTableTotal: inclusionPolicyRulesSchema.extend({
    scope: z.literal('pricingTableTotal'),
  }),
  versionPrice: inclusionPolicyRulesSchema.extend({
    scope: z.literal('versionPrice'),
  }),
  budget: inclusionPolicyRulesSchema.extend({
    scope: z.literal('budget'),
  }),
  export: inclusionPolicyRulesSchema.extend({
    scope: z.literal('export'),
  }),
});

export const inclusionPolicyResultSchema = z.object({
  pricingTableDisplay: z.boolean(),
  pricingTableTotal: z.boolean(),
  versionPrice: z.boolean(),
  budget: z.boolean(),
  export: z.boolean(),
});

export type InclusionPolicyScope = z.infer<typeof inclusionPolicyScopeSchema>;
export type InclusionDecision = z.infer<typeof inclusionDecisionSchema>;
export type ParentChildInclusionMode = z.infer<
  typeof parentChildInclusionModeSchema
>;
export type PricingInclusionPolicy = z.infer<
  typeof pricingInclusionPolicySchema
>;
export type PricingInclusionPolicies = z.infer<
  typeof pricingInclusionPoliciesSchema
>;
export type InclusionPolicyResult = z.infer<typeof inclusionPolicyResultSchema>;
